import {
  columnFilteringFeature,
  columnVisibilityFeature,
  createFilteredRowModel,
  createSortedRowModel,
  filterFn_includesString as includesStringFilterFn,
  metaHelper,
  rowSelectionFeature,
  rowSortingFeature,
  sortFn_alphanumeric as alphanumericSortFn,
  tableFeatures,
} from '@tanstack/react-table';

import type { TableLoadingMeta } from '../table-internals/table-loading-meta.js';

export type ExportType =
  'text' | 'integer' | 'decimal' | 'currency' | 'percent' | 'date' | 'datetime' | 'boolean';

export interface DimeColumnMeta {
  /** Human-friendly column name, used by the column-visibility menu and as the export header. */
  label?: string;
  /** Applied to the column's `<th>`, so a column can fix its width rather than be sized by its content. */
  headerClassName?: string;
  /** Export value for a cell-only column; `never` because TanStack's meta has no row type. */
  exportValue?: (row: never) => string | number | null;
  /** Starts the column hidden; ignored when the caller controls columnVisibility. */
  defaultHidden?: boolean;
  /** Declare on money and percent columns: inference can't tell a price from a count. */
  exportType?: ExportType;
}

export const dimeTableFeatures = tableFeatures({
  rowSortingFeature,
  columnFilteringFeature,
  columnVisibilityFeature,
  rowSelectionFeature,
  sortedRowModel: createSortedRowModel(),
  filteredRowModel: createFilteredRowModel(),
  filterFns: { includesString: includesStringFilterFn },
  sortFns: { alphanumeric: alphanumericSortFn },
  columnMeta: metaHelper<DimeColumnMeta>(),
  tableMeta: metaHelper<TableLoadingMeta>(),
});

export type DimeTableFeatures = typeof dimeTableFeatures;
